if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.onAddToCartClick = this.onAddToCartClick.bind(this);
      this.onAddToCartKeydown = this.onAddToCartKeydown.bind(this);
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.productsPerRow;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow);

      this.init();
      this.addEventListener("click", this.onAddToCartClick);
      this.addEventListener("keydown", this.onAddToCartKeydown);
    }

    onAddToCartKeydown(event) {
      const button = event.target.closest("[data-hani-collection-add]");
      if (!button) return;
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      button.click();
    }

    onAddToCartClick(event) {
      const button = event.target.closest("[data-hani-collection-add]");
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.variantId;
      if (!variantId || button.getAttribute("aria-disabled") === "true") return;

      const wasDisabled = button.getAttribute("aria-disabled") === "true";
      button.setAttribute("aria-disabled", "true");
      button.classList.add("is-loading");

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", "1");
      formData.append("sections", sectionsToBundle);
      formData.append("sections_url", window.location.pathname);

      const config = typeof fetchConfig === "function"
        ? fetchConfig("javascript")
        : { method: "POST", headers: { Accept: "application/json" } };
      config.headers = config.headers || {};
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = formData;

      const cartAddUrl = window.MinimogSettings?.routes?.cart_add_url || "/cart/add.js";
      fetch(cartAddUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            window.MinimogTheme?.Notification?.show({
              target: document.body,
              method: "appendChild",
              type: "error",
              message: response.message || response.description,
              last: 3000,
              sticky: true,
            });
            return;
          }

          if (window.MinimogSettings?.use_ajax_atc === false) {
            window.location = window.MinimogSettings?.routes?.cart || "/cart";
            return;
          }

          const cartUpdateEvent = window.MinimogTheme?.pubSubEvents?.cartUpdate;
          const openCartDrawer = () => {
            const cartDrawer = document.querySelector("m-cart-drawer");
            if (cartDrawer && typeof cartDrawer.open === "function") {
              cartDrawer.open();
              return true;
            }
            return false;
          };
          if (window.MinimogEvents && cartUpdateEvent) {
            window.MinimogEvents.emit(cartUpdateEvent, {
              cart: response,
              productVariantId: variantId,
            });
            if (!openCartDrawer()) {
              document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
            }
          } else {
            document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (wasDisabled) {
            button.setAttribute("aria-disabled", "true");
          } else {
            button.removeAttribute("aria-disabled");
          }
          button.classList.remove("is-loading");
        });
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("m-recently-viewed");
          this.products = recommendations.querySelectorAll(".m-product-card, .hani-collection__card").length;
          if (this.products > 0) {
            this.classList.remove("m:hidden");
          }
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });

            MinimogTheme.CompareProduct?.setCompareButtonsState();
            MinimogTheme.Wishlist?.setWishlistButtonsState();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }

      if (this.products <= parseInt(this.items)) {
        slideControls && slideControls.classList.add("m:hidden");
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = slideContainer.querySelector(".swiper-wrapper").childElementCount;

      slideContainer && slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: this.products <= parseInt(this.items) ? false : true,
        pagination: this.showPagination
          ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          }
          : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1024: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              // Calculate controls position
              const firstItem = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton && prevButton.classList.remove("m:hidden");
                nextButton && nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer && slideContainer.swiper;
    }

    getQueryString() {
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }
  }
  customElements.define("m-recently-viewed", MRecentlyViewed);
}
